// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3vNLT","detailsBorder":"styles_detailsBorder__G4jR2"};